import { render, staticRenderFns } from "./CategorizedFaq.vue?vue&type=template&id=7c25169a"
import script from "./CategorizedFaq.vue?vue&type=script&lang=js"
export * from "./CategorizedFaq.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports